import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_EFFORT_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const EffortReport = lazy(() =>
  import('../../../screens/EffortReport')
    .then(module => ({default: module.EffortReport})));

const EffortReportNavigation = [
  {
    path: ROUTE_EFFORT_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EffortReport />
      </Suspense>
    ),
  },
];

export default EffortReportNavigation;
